import {
  authenticate
} from '../../api'

export default {

  state: {
    accessToken: localStorage.getItem('token') || '',
    status: '',
    errorMessage: ''
  },

  actions: {

    LOGIN: ({ commit }, { username, password }) => {
      commit('AUTH_REQUEST')
      return authenticate(username, password).then(token => {
        localStorage.setItem('token', token)
        commit('AUTH_SUCCESS', token)
        return null
      }).catch(error => {

        if(error.response) {
          commit('AUTH_ERROR', error.response.data.error)
        } else if (error.request) {
          commit('AUTH_ERROR', 'Request error')
        } else {
          commit('AUTH_ERROR', error.message)
        }

        return error.response.data.error

      })
    },

    LOGOUT: ({ commit }) => {
      return new Promise((resolve) => {
        commit('AUTH_LOGOUT')
        localStorage.removeItem('token')
        resolve()
      })
    },

  },

  mutations: {

    AUTH_REQUEST: (state) => {
      state.status = 'loading'
      state.errorMessage = null
    },

    AUTH_SUCCESS: (state, { token }) => {
      state.status = 'successful'
      state.accessToken = token
    },

    AUTH_ERROR: (state, error) => {
      state.errorMessage = error
      state.status = 'error'
    },

    AUTH_LOGOUT: (state) => {
      state.accessToken = null
      state.status = ''
    }

  },

  getters: {

    isLoggedIn (state) {
      if (!state.accessToken) return false
      try {
        const encoded = state.accessToken.split('.')[1]
        const payload = JSON.parse(atob(encoded))
        return payload.exp > (Date.now() / 1000)
      } catch (err) {
        return false
      }
    }

  }

}
